export default __webpack_public_path__ + "static/ethan-4097ea05988668609efe0bd0bec4e48a.jpg";